(function () {
  var root = document.querySelector('[data-oj-brand-filter]');
  if (!root) return;

  var input = root.querySelector('[data-oj-brand-filter-input]');
  var empty = root.querySelector('[data-oj-brand-filter-empty]');
  var items = document.querySelectorAll('[data-oj-brand-filter-item]');
  var groups = document.querySelectorAll('[data-oj-brand-filter-group]');

  if (!input || !items.length) return;

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function updateGroupVisibility() {
    groups.forEach(function (group) {
      var visibleItem = group.querySelector('[data-oj-brand-filter-item]:not([hidden])');
      group.hidden = !visibleItem;
    });
  }

  function filterBrands() {
    var query = normalize(input.value);
    var visibleCount = 0;

    items.forEach(function (item) {
      var name = normalize(item.getAttribute('data-brand-name') || item.textContent);
      var matches = !query || name.indexOf(query) !== -1;
      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    updateGroupVisibility();

    if (empty) {
      empty.hidden = visibleCount !== 0;
    }
  }

  input.addEventListener('input', filterBrands);
})();
